export const formatDate = (inputDate: string) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  const dateParts = inputDate.split("-");
  const year = dateParts[0];
  const monthIndex = parseInt(dateParts[1]) - 1;
  const day = dateParts[2];

  const formattedDate = `${months[monthIndex]} ${day}`;
  return formattedDate;
};

export const formatFullDate = (inputDate: string) => {
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    date
  );
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedDate = `${day} ${month}, ${hours % 12 || 12}:${minutes
    .toString()
    .padStart(2, "0")} ${ampm}`;
  return formattedDate;
};

export const formatSettlementDate = (inputDate: number | Date | undefined) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  if (inputDate) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    const formattedMinute = minute.toString().padStart(2, "0");

    const formattedDate = `${day} ${month}, ${year}, ${formattedHour}:${formattedMinute} ${ampm}`;

    return formattedDate;
  } else {
    return "-";
  }
};

export const downloadPdf = async (pdfLink: string) => {
  if (pdfLink) {
    const link = document.createElement("a");
    link.href = pdfLink;
    link.target = "_blank";
    link.download = "document.pdf";
    link.click();
  }
};

export const formatTransactionDate = (inputDate: number | Date | undefined) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  if (inputDate) {
    const dateString: any = inputDate?.toString().split(".");
    // const dateWithoutTimeZone = new Date(
    //   dateString.replace(
    //     /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3})[+-]\d{2}:\d{2}/,
    //     "$1"
    //   )
    // );
    const dateWithoutTimeZone = new Date(dateString[0]);

    const date = new Date(dateWithoutTimeZone);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    const formattedMinute = minute.toString().padStart(2, "0");

    const formattedDate = `${day} ${month}, ${year}, ${formattedHour}:${formattedMinute} ${ampm}`;

    return formattedDate;
  } else {
    return "-";
  }
};
